import { render, staticRenderFns } from "./InvoiceHistoryItem.vue?vue&type=template&id=74be32a1&scoped=true"
import script from "./InvoiceHistoryItem.vue?vue&type=script&lang=js"
export * from "./InvoiceHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./InvoiceHistoryItem.vue?vue&type=style&index=0&id=74be32a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be32a1",
  null
  
)

export default component.exports